var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmileRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.9 9.55059L4.6 9.15059L3.8 9.75059L4.1 10.1506L4.9 9.55059ZM10.9 10.1506L11.2 9.75059L10.4 9.15059L10.1 9.55059L10.9 10.1506ZM7.5 14.8506C3.91015 14.8506 1 11.9404 1 8.35059H0C0 12.4927 3.35786 15.8506 7.5 15.8506V14.8506ZM14 8.35059C14 11.9404 11.0899 14.8506 7.5 14.8506V15.8506C11.6421 15.8506 15 12.4927 15 8.35059H14ZM7.5 1.85059C11.0899 1.85059 14 4.76074 14 8.35059H15C15 4.20845 11.6421 0.850586 7.5 0.850586V1.85059ZM7.5 0.850586C3.35786 0.850586 0 4.20845 0 8.35059H1C1 4.76074 3.91015 1.85059 7.5 1.85059V0.850586ZM4 6.85059H5V5.85059H4V6.85059ZM10 6.85059H11V5.85059H10V6.85059ZM10.1 9.55059C8.8 11.2839 6.2 11.2839 4.9 9.55059L4.1 10.1506C5.8 12.4173 9.2 12.4173 10.9 10.1506L10.1 9.55059Z",
    fill: "#C20000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileRed);
export default __webpack_public_path__ + "static/media/smile-red.b2346a099187fc759e00f561b19c858e.svg";
export { ForwardRef as ReactComponent };